module.exports = "/packs/start_course-8287af856d87feb0b2c7901349c7429c.png";